import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import {buildTree} from 'lib/categories';
import Topics from '../components/topics';
import ArticleList from '../components/articles/ArticleList';
import VideoList from '../components/videos/VideoList';
import LiveClasses from '../components/live-classes';
import Guides from '../components/guides';
import styles from './index.module.scss';

function getPopularVideos(data) {
  const {GATSBY_WISTIA_POPULAR_VIDEOS_PROJECT_ID} = process.env;

  return data.allWistiaVideo.edges
    .map(({node: video}) => video)
    .filter(
      video =>
        video.project.id ===
        parseInt(GATSBY_WISTIA_POPULAR_VIDEOS_PROJECT_ID, 10)
    );
}

const IndexPage = ({data}) => {
  const {
    allHelpScoutArticle: {edges: articleEdges},
    allHelpScoutCategory: {edges: categoryEdges},
  } = data;

  const articles = articleEdges.map(({node: article}) => article);

  const categoryTree = buildTree(categoryEdges, articleEdges);

  return (
    <div>
      <Topics categories={categoryTree} />
      <section className={classNames('section', styles.Section)}>
        <div className="container container-960">
          <div className="columns">
            <div className={classNames('column is-5', styles.Column)}>
              <ArticleList articles={articles.slice(0, 5)} />
            </div>
            <div
              className={classNames(
                'column is-5 is-offset-2',
                styles.Column,
                styles['Column--offset']
              )}
            >
              <VideoList useEmbed={true} videos={getPopularVideos(data)} />
            </div>
          </div>
        </div>
      </section>
      <LiveClasses className={styles.Section} />
      <section className={classNames('section', styles.Section)}>
        <div className="container container-960">
          <Guides />
        </div>
      </section>
    </div>
  );
};

IndexPage.propTypes = {
  data: PropTypes.object.isRequired,
};

// eslint-disable-next-line
export const query = graphql`
  query IndexPageQuery {
    allHelpScoutCategory(
      sort: {fields: [order]}
      filter: {articleCount: {ne: 0}}
    ) {
      edges {
        node {
          slug
          name
          id
          articleCount
          description
        }
      }
    }
    allHelpScoutArticle {
      edges {
        node {
          id
          name
          slug
          number
          categories
        }
      }
    }
    allWistiaVideo {
      edges {
        node {
          thumbnail {
            url
          }
          duration
          name
          project {
            id
          }
          hashed_id
        }
      }
    }
  }
`;

export default IndexPage;



// WEBPACK FOOTER //
// ./src/pages/index.js